import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormViewDetailComponent} from './components/form-view-detail/form-view-detail.component';
import {
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
} from '@angular/material';
import {CoreModule} from '../core/core.module';
import {FormViewFieldComponent} from './components/form-view-field/form-view-field.component';
import {FormViewListComponent} from './components/form-view-list/form-view-list.component';
import {FormViewService} from './services/form-view.service';
import {FieldValueModalComponent} from './components/field-value-modal/field-value-modal.component';
import {FormViewDataListComponent} from './components/data/form-view-data-list/form-view-data-list.component';
import {FormViewDataDetailComponent} from './components/data/form-view-data-detail/form-view-data-detail.component';
import {FXDirectiveModule} from 'app/directives/fx.directive';
import {SaveViewDialogComponent} from './components/data/save-view-dialog/save-view-dialog.component';
import { ConfirmDialogModule, DialogModule } from 'primeng/primeng';
import { FormViewDataEditorComponent } from './components/data/form-view-data-editor/form-view-data-editor.component';
import {ViewFieldComponent} from "./components/view-field/view-field.component";

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatCardModule,
        MatInputModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        ConfirmDialogModule,
        DialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSortModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatButtonModule,
        FXDirectiveModule
    ],
    entryComponents: [FieldValueModalComponent, SaveViewDialogComponent],
    declarations: [FormViewDetailComponent, FormViewFieldComponent, FormViewListComponent,
        FieldValueModalComponent, ViewFieldComponent, FormViewDataListComponent, FormViewDataDetailComponent, SaveViewDialogComponent, FormViewDataEditorComponent],
    providers: [
        FormViewService
    ]
})
export class FormViewsModule {
}



// WEBPACK FOOTER //
// ./src/app/form-views/form-views.module.ts